import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TermsOfServiceAcceptanceDto } from './../../models/terms-of-service/terms-of-service-acceptance.dto';
import { TermsOfServiceStatusDto } from './../../models/terms-of-service/terms-of-service-status.dto';
import { AcceptTermsOfServiceDto } from './../../models/terms-of-service/terms-of-service.dto';

@Injectable({
  providedIn: 'root'
})
export class TermsOfServiceService {
  private readonly baseUrl = 'api/terms-of-service';

  private readonly http = inject(HttpClient);

  download(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/download`, {
      responseType: 'blob'
    });
  }

  getContentText(): Observable<string> {
    return this.http.get(`${this.baseUrl}/content/text`, {
      responseType: 'text'
    });
  }

  getContentHtml(): Observable<string> {
    return this.http.get(`${this.baseUrl}/content/html`, {
      responseType: 'text'
    });
  }

  getVersion(): Observable<{ version: string }> {
    return this.http.get<{ version: string }>(`${this.baseUrl}/version`);
  }

  accept(version: AcceptTermsOfServiceDto): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/accept`, version);
  }

  getStatus(): Observable<TermsOfServiceStatusDto> {
    return this.http.get<TermsOfServiceStatusDto>(`${this.baseUrl}/status`);
  }

  getHistory(): Observable<TermsOfServiceAcceptanceDto> {
    return this.http.get<TermsOfServiceAcceptanceDto>(
      `${this.baseUrl}/history`
    );
  }
}
